import { createFileRoute } from '@tanstack/react-router'
import Visits from '../../components/Visits'

export const Route = createFileRoute('/visits/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Visits/>
}
